
import { Encryptor, LzEncryptor } from "./Encryptor";

export const CacheManager = {

    PROFILES_KEY: "rivtn.ps",
    __cacheImpl__: localStorage,
    __encryptorImpl__: LzEncryptor,

    setStorage(cacheImpl: Storage) {
        CacheManager.__cacheImpl__ = cacheImpl;
    },

    setEncryptor(encryptorImpl: Encryptor) {
        CacheManager.__encryptorImpl__ = encryptorImpl;
    },

    has(key: string) {
        const item = CacheManager.__cacheImpl__.getItem(key);
        return (item !== null && item !== "")
    },

    remove(key: string) {
        CacheManager.__cacheImpl__.removeItem(key);
    },

    insecurePut(key: string, value: string | number | Object) {
        const valueToStore = JSON.stringify({
            value,
            type: typeof value,
        });
        CacheManager.__cacheImpl__.setItem(key, CacheManager.__encryptorImpl__ ? CacheManager.__encryptorImpl__.encrypt(valueToStore) : valueToStore);
    },

    put(key: string, value: string | number | Object) {
        if (!CacheManager.has(CacheManager.PROFILES_KEY)) return;
        CacheManager.insecurePut(key, value);
    },

    putProfile(profile: any, onDone?: () => void) {
        const profiles = CacheManager.get(CacheManager.PROFILES_KEY) ?? [];
        const existingIndex = profiles?.findIndex((p: any) => (p.session_token === profile.session_token || p.email === profile.email));
        if (existingIndex > -1) {
            profiles.splice(existingIndex, 1);
        }
        profiles.push(profile);
        CacheManager.insecurePut(CacheManager.PROFILES_KEY, profiles);
        onDone?.();
    },

    get(key: string, fallback?: any) {
        if (!CacheManager.has(key)) {
            return fallback;
        }
        const cacheValue = CacheManager.__cacheImpl__.getItem(key) as string;
        const valueToStore = JSON.parse(CacheManager.__encryptorImpl__ ? CacheManager.__encryptorImpl__.decrypt(cacheValue) : cacheValue);
        return valueToStore.value;
    },

    clear() {
        CacheManager.__cacheImpl__.clear();
    }

}
